import React, {FC, useRef, useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import {getUserByToken} from './AuthCRUD'
import {RootState} from '../../../../setup'
import {actions as workspaceActions, IWorkspaceState} from '../../../@reducer/WorkspaceRedux'
import {UserWorkspace} from '../models/UserModel'
import {useFaviconAndTitle, useWorkspaceStyles} from '../../../features'
import {actions as authActions} from '../../auth/redux/AuthRedux'
const transformUserWorkspace = (userWorkspace: UserWorkspace): IWorkspaceState => ({
    id: userWorkspace.id,
    name: userWorkspace.name || 'MyWebforce',
    colors: {
        primary: userWorkspace.color?.main || '#0094f3',
        secondary: userWorkspace.color?.second || '#e1006d',
        textColor: userWorkspace.color?.text || '#fff',
    },
    is_active: userWorkspace.is_active || 0,
    images: {
        favicon: userWorkspace.icon || '',
        logo: userWorkspace.logo || '',
    },
})

const AuthInit_: FC = ({children}) => {

    const dispatch = useDispatch()
    const didRequest = useRef(false)
    const [showSplashScreen, setShowSplashScreen] = useState(true)
    const accessToken = useSelector((state: RootState) => state.auth.accessToken)

    useWorkspaceStyles()
    useFaviconAndTitle()

    // Management of the initialization of authentication
    useEffect(() => {

        console.log('****************** AuthInit_ ******************')
        const abortController = new AbortController()

        const initializeAuth = async () => {
            try {
                if (!accessToken) {
                    dispatch(authActions.logout())
                    return
                }

                if (!didRequest.current) {
                    const user = await getUserByToken(abortController.signal)
                    dispatch(authActions.fulfillUser(user))

                    if (user?.workspace) {
                        const workspace = transformUserWorkspace(user.workspace)
                        dispatch(workspaceActions.setWorkspace(workspace))
                    }
                }
            } catch (error) {
                if (!abortController.signal.aborted) {
                    dispatch(authActions.logout())
                }
            } finally {
                if (!abortController.signal.aborted) {
                    setShowSplashScreen(false)
                }
            }
        }

        initializeAuth()

        return () => {
            abortController.abort()
            didRequest.current = true
        }
    }, [accessToken, dispatch])

    return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>

}
export default AuthInit_
